import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import ScheduledPostsDropdown from './components/ScheduledPostsDropdown';

export default function () {
	// We want (maybe) to add an item to the Header where the notifications menu is located
	extend(HeaderSecondary.prototype, 'items', function (items) {
		if (!app.session.user || !app.session.user.canSchedulePosts()) {
			// if no user is logged in, do nothing
			// if the user isn't allowed to schedule posts, he should not see this dropdown menu,
			// so do nothing
			return;
		}

		// Display the dropdown menu, only if there are some scheduled posts
		if (app.session.user.scheduledPostsCount() > 0) {
			items.add('scheduled-posts', <ScheduledPostsDropdown state={app.scheduledPosts} />, 20);
		}
	});
}
